module.exports = __webpack_public_path__ + "img/damage-yellow.25bf58d0.svg";